(ns frontend.test.page-table
  (:require [frontend.routing :as routing]
            [reagent.core :as r]
            [common.intelligence.common :as ic]))

(def table-headlines
  [{:key   :company-name
    :title "Company name"}
   {:key   :company-description
    :title "Company description"}
   {:key   :company-address
    :title "Company address"}])

(def test-entities
  [{:entity.type                 :entity.type/company
    :asset/name                "Company1"
    :company/company-description "Description1"
    :asset/street-address      "Walley street 14"}
   {:entity.type                 :entity.type/company
    :asset/name                "Company2"
    :company/company-description "Description2"
    :asset/street-address      "Oxford street 1"}
   {:entity.type                 :entity.type/company
    :asset/name                "Company3"
    :company/company-description "Description3"
    :asset/street-address      "Jackson street 1"}
   {:entity.type                 :entity.type/company
    :asset/name                "Company4"
    :company/company-description "Description4"
    :asset/street-address      "Dawnson street 1"}])

(defn table-view [columns entities]
  [:div.table__wrapper.table-responsive
   [:table.zap-table.zap-table--striped
    [:thead.zap-table__head
     [:tr.zap-table__row
      (doall (for [column columns]
               ^{:key (:key column)}
               [:th.zap-table__headline (:title column)]))]]
    [:tbody.zap-table__body
     [:tr.zap-table__row
      [:td.zap-table__cell "Test1"]
      [:td.zap-table__cell "Test2"]
      [:td.zap-table__cell "Test3"]]
     [:tr.zap-table__row
      [:td.zap-table__cell "Test1"]
      [:td.zap-table__cell "Test2"]
      [:td.zap-table__cell "Test3"]]
     [:tr.zap-table__row
      [:td.zap-table__cell "Test1"]
      [:td.zap-table__cell "Test2"]
      [:td.zap-table__cell "Test3"]]]]])

(defmethod routing/render-view :test/page-table [{:keys [route-params]}]
  (let [state (r/atom {})]
    (fn []
      (let []
        [:h2.title-h2.mb-2 "Tables"]
        [table-view table-headlines test-entities]))))
